import axios from "axios"
import { apiUrl } from "../enumerations/constants"

export const createOrderRequest = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/order_request`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const getOrderRequests = async (token, query) => {
  const { data: response } = await axios.get(`${apiUrl}/order_requests?${query}`, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const getOrderRequest = async (token, id) => {
  const { data: response } = await axios.get(`${apiUrl}/order_request?id=${id}`, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const completeOrderRequests = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/order_requests/complete`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const completeOrderRequest = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/order_request/complete`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const rejectOrderRequests = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/order_requests/reject`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}

export const rejectOrderRequest = async (token, payload) => {
  const { data: response } = await axios.post(`${apiUrl}/order_request/reject`, payload, {
    headers: {
      "Token": token
    }
  })
  return response
}
